/* TALINA BEACH — avisos de estoque real por tamanho, editáveis no tema.
   Nunca informa "restam X" quando o estoque não é verificável. */
(function () {
  'use strict';
  var selector = '[data-talina-size-stock-notice]';
  var cache = new WeakMap();
  function variantsFor(picker) {
    var el = picker && picker.parentElement && picker.parentElement.querySelector('[data-talina-variant-stock-json]');
    if (!el) return [];
    if (cache.has(el)) return cache.get(el);
    var items = [];
    try { items = JSON.parse(el.textContent || '[]'); } catch (err) {}
    cache.set(el, items);
    return items;
  }
  function selection(picker, length) {
    var opts = [];
    for (var i = 1; i <= length; i++) {
      var el = picker.querySelector('input[name="option' + i + '"]:checked') ||
               picker.querySelector('select[name="option' + i + '"]');
      opts.push(el ? el.value : null);
    }
    return opts;
  }
  function limit(value, fallback) {
    var n = Number(value);
    return Number.isFinite(n) && n > 0 ? n : fallback;
  }

  // DEMONSTRAÇÃO FIXA, NÃO É ESTOQUE NEM INDICA VENDAS.
  // Ativa apenas no editor, na prévia do rascunho ou com parâmetro explícito.
  function demoActive(el) {
    if (el.dataset.demoEnabled === 'false') return false;
    var design = el.dataset.demoEditor === 'true' ||
      !!(window.Shopify && window.Shopify.designMode);
    var draftPreview = !!(window.Shopify && window.Shopify.theme &&
      String(window.Shopify.theme.role || '').toLowerCase() === 'unpublished');
    var previewParam = false;
    try {
      var query = new URLSearchParams(window.location.search);
      previewParam = query.get('talina_stock_demo') === '1' ||
        query.get('preview_theme_id') === '189343957170';
    } catch (e) {}
    return design || draftPreview || previewParam;
  }
  function demoMessage(size, el) {
    var count;
    if (size === 'M' || size === 'G') {
      count = Number(size === 'M' ? el.dataset.demoMFixed : el.dataset.demoGFixed);
      if (!Number.isFinite(count) || count < 1) count = size === 'M' ? 5 : 8;
      return count === 1 ? 'Resta apenas 1 unidade!' : 'Restam apenas ' + count + ' unidades!';
    }
    return el.dataset.demoOthersText || 'Restam poucas unidades';
  }
  function message(size, variant, el) {
    if (el.dataset.enabled === 'false') return '';
    size = String(size || '').trim().toUpperCase();
    if (demoActive(el)) return demoMessage(size, el);
    if (!variant || !variant.available || !variant.managed) return '';
    var qty = Number(variant.quantity);
    if (!Number.isInteger(qty) || qty <= 0) return '';
    size = String(size || '').trim().toUpperCase();
    var key, threshold;
    if (size === 'M') { key = 'M'; threshold = limit(el.dataset.thresholdM, 8); }
    else if (size === 'G') { key = 'G'; threshold = limit(el.dataset.thresholdG, 5); }
    else if (size === 'P') { key = 'P'; threshold = limit(el.dataset.thresholdP, 8); }
    else if (size === 'GG') { key = 'Gg'; threshold = limit(el.dataset.thresholdGg, 5); }
    else { key = 'Other'; threshold = limit(el.dataset.thresholdOther, 5); }
    if (qty > threshold) return '';
    var template = el.dataset['text' + key] || ((size === 'M' || size === 'G') ? 'Restam apenas {count} unidades!' : size === 'GG' ? 'Quase esgotado' : 'Restam poucas unidades');
    var rendered = template.replace(/\{count\}/g, String(qty));
    if (qty === 1) rendered = rendered.replace(/Restam apenas 1 unidades/i, 'Resta apenas 1 unidade');
    return rendered;
  }
  function update(picker) {
    var variants = variantsFor(picker);
    var sizeNotices = Array.from(picker.querySelectorAll(selector));
    if (!sizeNotices.length) return;
    var maxSizePosition = sizeNotices.reduce(function (max, n) {
      return Math.max(max, Number(n.dataset.optionPosition) || 0);
    }, 0);
    var numOptions = variants.length && Array.isArray(variants[0].options)
      ? variants[0].options.length : maxSizePosition;
    var opts = selection(picker, numOptions);
    var variant = variants.find(function (v) {
      return Array.isArray(v.options) && v.options.every(function (vOpt, i) {
        return String(vOpt) === String(opts[i]);
      });
    });
    sizeNotices.forEach(function (notice) {
      var position = Number(notice.dataset.optionPosition) - 1;
      var msg = position >= 0 ? message(opts[position], variant, notice) : '';
      var field = notice.querySelector('[data-talina-size-stock-text]');
      if (field) field.textContent = msg;
      var label = notice.querySelector('[data-talina-stock-demo-label]');
      var isSimulation = demoActive(notice);
      if (label) {
        label.hidden = !isSimulation || !msg;
        label.style.display = label.hidden ? 'none' : 'block';
        if (isSimulation && msg) label.textContent = 'DEMONSTRAÇÃO · valores ilustrativos, não representam estoque';
      }
      notice.hidden = !msg;
      notice.style.display = msg ? 'block' : 'none';
    });
  }
  function updateAll() {
    document.querySelectorAll('product-variants').forEach(update);
  }
  function schedule() {
    window.setTimeout(updateAll, 0);
    window.setTimeout(updateAll, 130);
  }
  document.addEventListener('change', function(e) {
    if (e.target.closest('product-variants')) schedule();
  }, true);
  document.addEventListener('click', function(e) {
    if (e.target.closest('.combo-box__option-item, .block-swatch__item, .variant-swatch__item')) schedule();
  }, true);
  ['variant:changed', 'variant:change', 'product:variant-change'].forEach(function(e) {
    document.addEventListener(e, schedule);
  });
  window.addEventListener('popstate', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll, {once:true});
  else updateAll();
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function(records) {
      if (records.some(function(r) {
        return Array.from(r.addedNodes).some(function(n) {
          return n.nodeType === 1 && ((n.matches && (n.matches('product-variants') || n.matches(selector))) ||
             (n.querySelector && n.querySelector(selector)));
        });
      })) schedule();
    });
    observer.observe(document.documentElement, {childList:true, subtree:true});
  }
}());
